export const truncateString = (string: string, length = 40): string =>
	string?.length > length ? `${string.substring(0, length)}…` : string
